import { Grid } from '@mui/material';

import { ProductDataProps } from './props';
import { useProductData } from './hook';

import Loading from '../../../../../components/general/loadings/loading';
import FieldText from '../../../../../components/general/fields/fieldText';
import { Checkbox } from '../../../../../components/general/fields/checkbox';

export const ProductData = ({ product, loading }: ProductDataProps) => {
    const { formik } = useProductData(product);

    return loading ? (
        <Loading />
    ) : (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
        >
            <Grid item xs={12} sm={4}>
                <FieldText
                    label="Código"
                    name="code"
                    size="small"
                    disabled
                    value={formik.values.code}
                    onChange={undefined}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <FieldText
                    label="Nombre"
                    name="name"
                    size="small"
                    disabled
                    value={formik.values.name}
                    onChange={undefined}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <FieldText
                    label="Unidad de Captura SFC"
                    name="sfcCaptureUnit"
                    size="small"
                    disabled
                    value={formik.values.sfcCaptureUnit}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <FieldText
                    label="Unidad de Captura SFC Nuevo"
                    name="sfcCaptureUnitNew"
                    size="small"
                    disabled
                    value={formik.values.sfcCaptureUnitNew}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <Checkbox
                    label="Activo"
                    disabled
                    checked={Boolean(formik.values.active)}
                    onChange={() => {
                        formik.setFieldValue('active', !formik.values.active);
                    }}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <Checkbox
                    label="Aplica Pqr"
                    disabled
                    checked={Boolean(formik.values.applyPqr)}
                    onChange={() => {
                        formik.setFieldValue(
                            'applyPqr',
                            !formik.values.applyPqr
                        );
                    }}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <Checkbox
                    label="Aplica Escalamiento"
                    disabled
                    checked={Boolean(formik.values.applyEscalations)}
                    onChange={() => {
                        formik.setFieldValue(
                            'applyEscalations',
                            !formik.values.applyEscalations
                        );
                    }}
                />
            </Grid>
            <Grid item xs={12}>
                <FieldText
                    label="Descripción"
                    name="extra"
                    size="small"
                    rows={2}
                    disabled
                    value={formik.values.description}
                    onChange={undefined}
                />
            </Grid>
        </Grid>
    );
};
